/** Product brand — acronym-first; full expansion in side nav / title */
const brand = {
  name: 'SOCR',
  expansion: 'Support Operations Cognitive Runtime',
  /** Document / window title */
  documentTitle: 'SOCR · Support Operations Cognitive Runtime',
  shortDescription: 'Keysys Support Operations Cognitive Runtime',
  boards: {
    dashboard: {
      id: 'dashboard',
      label: 'Dashboard',
      path: '/'
    },
    vulnerabilities: {
      id: 'vulnerabilities',
      label: 'Vulnerabilities',
      path: '/vulnerabilities'
    },
    upgrades: {
      id: 'upgrades',
      label: 'Upgrades',
      path: '/upgrades'
    },
    clientOrganization: {
      id: 'clientOrganization',
      label: 'Client Organization',
      path: '/client-organization'
    }
  }
}

/** Ordered side-nav entries */
const brandNavItems = [
  brand.boards.dashboard,
  brand.boards.vulnerabilities,
  brand.boards.upgrades,
  brand.boards.clientOrganization
]

export { brand, brandNavItems }
